import './App.css'
import HomePage from './pages/home'

function App() {
  return (
    <div>
      <HomePage />
    </div>
  )
}

export default App

